import { useLocation, useNavigate } from "react-router-dom";
import { MOBILE_NAV } from "./NavItems";
import { isNavSelected } from "./navMatch";

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      style={{
        position: "sticky",
        bottom: 0,
        zIndex: 10,
        display: "grid",
        gridTemplateColumns: `repeat(${MOBILE_NAV.length}, 1fr)`,
        background: "var(--ant-color-bg-container)",
        borderTop: "1px solid var(--ant-color-border)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      {MOBILE_NAV.map((it) => {
        const active = isNavSelected(it.to, location.pathname, location.search);
        return (
          <button
            key={it.key}
            type="button"
            onClick={() => navigate(it.to)}
            aria-label={it.label}
            style={{
              minHeight: 56,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              border: "none",
              background: "transparent",
              color: active ? "var(--ant-color-primary)" : "var(--ant-color-text-secondary)",
              fontSize: 13,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            <span style={{ fontSize: 22, lineHeight: 1 }}>{it.icon}</span>
            <span>{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
